<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Dosya</label>
            <file-uploader :accept="['pdf','doc','docx','xls','xlsx']" :value="value" valueParameter="File" ></file-uploader>
        </div>
    </div>
</template>

<script>
import FileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import DocumentOperationsApi from '@/api/document-operations'
export default {
    components:{
        FileUploader
    },
    props:{
        value:Object
    },
}
</script>

<style>

</style>